<template>
  <a-modal visible :title="name" @ok="handleOk" @cancel="handleCancel">
    <a-form-model-item
      v-for="(item,index) in pages"
      :label="item.title"
      :key="index"
      style="margin:0;padding:0;border:0;"
    >
      <a-checkbox-group
        v-model="pages[index].authority"
        :options="options[index]"
        :defaultValue="pages[index].authority"
        @change="onChange(pages[index].authority)"
      ></a-checkbox-group>
      <a-divider v-if="index===0" orientation="left">车间管理</a-divider>
      <a-divider v-if="index===3" />
      <a-divider v-if="index===5" orientation="left">成品管理</a-divider>
      <a-divider v-if="index===7" orientation="left">配样管理</a-divider>
      <a-divider v-if="index===9" orientation="left">订单管理</a-divider>
      <a-divider v-if="index===17" orientation="left">客户管理</a-divider>
      <a-divider v-if="index===19" />
      <a-divider v-if="index===21" orientation="left">价格日志</a-divider>
      <a-divider v-if="index===24" />
      <a-divider v-if="index===25" orientation="left">基本设定</a-divider>
    </a-form-model-item>
  </a-modal>
</template>

<script>
export default {
  data () {
    return {
      name: this.record.name + '的权限分配',
      el: [],
      pages: [
        // {
        //   title: '首页',
        //   key: 'index',
        //   authority: []
        // },
        {
          title: '人员管理',
          key: 'user',
          authority: []
        },
        {
          title: '车间列表',
          key: 'workShop',
          authority: []
        },
        {
          title: '车间型号',
          key: 'model',
          authority: []
        },
        {
          title: '型号含量',
          key: 'proportion',
          authority: []
        },
        {
          title: '原材料管理',
          key: 'rawMaterial',
          authority: []
        },
        {
          title: '半成品管理',
          key: 'parts',
          authority: []
        },
        {
          title: '成品配方',
          key: 'finishProduct',
          authority: []
        },
        {
          title: '成品附加费',
          key: 'finishSurcharge',
          authority: []
        },
        {
          title: '未添加配方',
          key: 'batchingFinishProductUn',
          authority: []
        },
        {
          title: '配样配方',
          key: 'batchingFinishProduct',
          authority: []
        },
        {
          title: '待审核订单',
          key: 'financeVerifyOrder',
          authority: []
        },
        {
          title: '销售订单',
          key: 'order',
          authority: []
        },
        {
          title: '备货订单',
          key: 'reserveOrder',
          authority: []
        },
        {
          title: '未发出订单',
          key: 'completeOrder',
          authority: []
        },
        {
          title: '已发出订单',
          key: 'sentOrder',
          authority: []
        },
        {
          title: '待一审订单',
          key: 'unconfirmedOrder',
          authority: []
        },
        {
          title: '待二审订单',
          key: 'unconfirmedOrder2',
          authority: []
        },
        {
          title: '审完成订单',
          key: 'confirmedOrder',
          authority: []
        },
        {
          title: '客户列表',
          key: 'client',
          authority: []
        },
        {
          title: '客户提成',
          key: 'clientCommission',
          authority: []
        },
        {
          title: '工资管理',
          key: 'salary',
          authority: []
        },
        {
          title: '利润管理',
          key: 'profit',
          authority: []
        },
        {
          title: '原材料日志',
          key: 'priceLog',
          authority: []
        },
        {
          title: '成品日志',
          key: 'finishProductLog',
          authority: []
        },
        {
          title: '配样日志',
          key: 'batchingLog',
          authority: []
        },
        {
          title: '文档管理',
          key: 'doc',
          authority: []
        },
        {
          title: '公司管理',
          key: 'company',
          authority: []
        },
        {
          title: '托盘管理',
          key: 'allPallet',
          authority: []
        },
        {
          title: '包装管理',
          key: 'allPack',
          authority: []
        },
        {
          title: '麦头管理',
          key: 'allMark',
          authority: []
        },
        {
          title: '项目设置',
          key: 'setting',
          authority: []
        }
      ],
      // pages: ['首页', '人员管理', '车间', '车间型号', '型号含量', '原材料管理', '半成品管理', '成品配方', '成品附加费', '未添加配方', '配样配方', '待审核订单', '全部订单', '未发出订单', '已发出订单', '已收货订单', '审完成订单', '客户提成', '工资', '利润', '价格日志'],
      options: [
        // [
        //   // 首页
        //   // { label: '进入页面', value: 'index' },
        //   { label: '查看所有订单', value: 'view' },
        //   { label: '变更状态', value: 'edit' },
        //   { label: '查看配方', value: 'formula' }
        // ],
        [
          // 人员管理
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' },
        ],
        // 车间
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' }
        ],
        // 车间型号
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' }
        ],
        // 型号含量
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' }
        ],
        // 原材料管理
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' }
        ],
        // 半成品管理
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' },
          { label: '修改配方', value: 'formula' },
        ],
        // 成品配方
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '修改配方', value: 'formula' }
        ],
        // 成品附加费
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' }
        ],
        // 未添加配方
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' },
          { label: '修改配方', value: 'formula' }
        ],
        // 配样配方
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' },
          { label: '修改配方', value: 'formula' }
        ],
        // 待审核订单
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '删除', value: 'del' },
          { label: '审核', value: 'verify' },
        ],
        // 全部订单
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' },
          { label: '备货', value: 'reserve' },
          { label: '查看配方', value: 'formula' },
        ],
        // 备货订单
        [
          { label: '查看', value: 'view' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' },
          { label: '取消备货', value: 'cancelReserve' }
        ],
        // 未发出订单
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' },
          { label: '确认发出', value: 'post' },
        ],
        // 已发出订单
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '确认收货/撤回', value: 'post' },
        ],
        // 待一审订单
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '编辑', value: 'edit' },
          { label: '审核', value: 'verify1' },
        ],
        // 待二审订单
        [
          { label: '查看', value: 'view' },
          { label: '编辑', value: 'edit' },
          { label: '审核', value: 'verify2' },
          { label: '审核日志', value: 'log' }
        ],
        // 审完成订单
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '删除', value: 'del' },
          { label: '审核日志', value: 'log' }
        ],
        [
          // 客户管理
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' }
        ],
        // 客户提成
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' }
        ],
        // 工资
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' }
        ],
        // 利润
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' }
        ],
        // 原材料日志
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '删除', value: 'del' }
        ],
        // 半成品日志
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '删除', value: 'del' }
        ],
        // 配样日志
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '删除', value: 'del' }
        ],
        [
          // 文档管理
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' }
        ],
        // 公司管理
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' }
        ],
        // 托盘管理
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' }
        ],
        // 包装管理
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' }
        ],
        // 麦头管理
        [
          // { label: '进入页面', value: 'index' },
          { label: '查看', value: 'view' },
          { label: '新建', value: 'create' },
          { label: '编辑', value: 'edit' },
          { label: '删除', value: 'del' }
        ],
        // 项目设置
        [
          { label: '查看', value: 'view' },
          { label: '编辑', value: 'edit' }
        ]
      ],
    }
  },
  async mounted () {
    let { data: res } = await this.$modelAjax.get('_User', {
      params: {
        where: {
          objectId: this.record.objectId
        }
      }
    })
    let r = res.results[0]

    for (let x in this.pages) {
      let demo = r.authority[this.pages[x].key]
      for (let key in demo) {
        if (demo[key]) {
          this.pages[x].authority.push(key)
        }
      }
    }
  },
  methods: {
    onChange (val) {
      // 若有新增、删除权限，则有查看权限
      if (
        val.indexOf('create') !== -1 ||
        val.indexOf('del') !== -1
      ) {
        if (val.indexOf('view') === -1) {
          val.push('view')
        }
      }
      // 若在某界面有权限，则可进入界面
      if (val.length !== 0 && val.indexOf('view') === -1) {
        val.push('view')
      }
    },
    async handleOk () {
      let obj = {}
      for (let i in this.pages) {
        let item = this.pages[i]
        obj[item.key] = {
          // index: item.authority.length !== 0,
          create: item.authority.indexOf('create') !== -1,
          del: item.authority.indexOf('del') !== -1,
          view: item.authority.indexOf('view') !== -1,
          edit: item.authority.indexOf('edit') !== -1,
          formula: item.authority.indexOf('formula') !== -1,
          verify: item.authority.indexOf('verify') !== -1,
          verify1: item.authority.indexOf('verify1') !== -1,
          verify2: item.authority.indexOf('verify2') !== -1,
          post: item.authority.indexOf('post') !== -1,
          log: item.authority.indexOf('log') !== -1,
          distribution: item.authority.indexOf('distribution') !== -1,
          reserve: item.authority.indexOf('reserve') !== -1,
          cancelReserve: item.authority.indexOf('cancelReserve') !== -1,
        }
      }

      try {
        await this.$modelAjax.put('_User', this.record.objectId, {
          authority: obj
        })
        this.$notification.success({
          message: '提交成功',
          description: '已完成权限分配'
        })
        this.vm.refresh()
        this.$emit('complete', 'cancel')
      } catch (e) {
        this.$notification.error({
          message: '网络错误',
          description: '网络错误'
        })

        this.$emit('complete')
      }
    },
    handleCancel () {
      this.$emit('complete')
    }
  },
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String, // 假如当前model显示为category格式，则会将当前的值传入
    title: String
  },
}
</script>

<style>
.checkbox-group{
  padding: 4px 8px;
}
</style>
